import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * `committee.racemarks.app/join?r=<encoded-race-path>` is the admin-side twin
 * of `racemarks.app/join`. It is reached via the URL switch trick: a global
 * admin who lands on `racemarks.app/join` swaps the hostname to
 * `committee.racemarks.app` (same path, same query) to investigate the race.
 *
 * Behaviour:
 *   - signed-in GlobalAdmin → redirect to `/admin/diagnostics?r=<path>`
 *   - signed-in non-admin   → redirect to `/unauthorized` (existing portal page)
 *   - signed out            → redirect to `/login`, preserving destination
 */
export default function JoinHandler() {
  const { user, loading, isGlobalAdmin } = useAuth();
  const location = useLocation();
  const search = location.search || '';

  if (loading) {
    return <div className="page"><p>Loading…</p></div>;
  }

  if (!user) {
    // Preserve the join URL so post-login can resume to /admin/diagnostics.
    return (
      <Navigate
        to="/login"
        state={{ from: { pathname: '/admin/diagnostics', search } }}
        replace
      />
    );
  }

  if (!isGlobalAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Navigate to={`/admin/diagnostics${search}`} replace />;
}
